import { motion } from "framer-motion";

export const scrollToSection = (id) => {
  const el = document.getElementById(id.replace(/^#/, ""));
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ index, eyebrow, title, description, center = false, testId }) => (
  <div className={`mb-12 lg:mb-16 ${center ? "text-center" : ""}`} data-testid={testId}>
    <Reveal>
      <p className="font-code text-xs sm:text-sm tracking-[0.25em] uppercase text-amber-400/90 mb-4">
        {index} <span className="text-slate-500">/</span> {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-50">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className={`mt-4 text-sm sm:text-base text-slate-400 leading-relaxed max-w-2xl ${center ? "mx-auto" : ""}`}>
          {description}
        </p>
      </Reveal>
    )}
  </div>
);

export const statusStyles = {
  Building: "text-amber-400 bg-amber-400/10 border-amber-400/30",
  Live: "text-emerald-400 bg-emerald-400/10 border-emerald-400/30",
  Experiment: "text-violet-400 bg-violet-400/10 border-violet-400/30",
  "Coming Soon": "text-cyan-400 bg-cyan-400/10 border-cyan-400/30",
};

export const StatusBadge = ({ status }) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-code text-[11px] tracking-wide ${statusStyles[status] || statusStyles.Building}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {status}
  </span>
);
